'use client';
import Link from 'next/link';
import './style.scss';
import AuthBgLight from './auth-bg-light.png';
import Image from 'next/image';
import { ModeToggle } from '@/components/ModeToggle';
import { Button } from "@/components/ui/button";
import NextAuthConfig from '@/auth.config';
import { FcGoogle } from "react-icons/fc";
import { FaLinkedin } from "react-icons/fa6";
import { signIn } from "next-auth/react"
import { JSX } from "react";

const ProviderIcons: { [key: string]: JSX.Element } = {
    Google: <FcGoogle size={24} style={{marginRight: 10 }} />,
    Linkedin: <FaLinkedin size={24} style={{marginRight: 10 }} />
}

export default function LoginPage(){
    
    return <>
        <div className="login-page">
            <div className="left">
                <div className="login-container">
                    <div className="logo">Spendbook</div>
                    <p className='pb-5'>Sign in to manage your statements and invoices.</p>
                        {NextAuthConfig.providers.map((provider, index: number) => (
                            <Button key={index} style={{width: '100%'}} onClick={() => signIn(provider.id)}>{ProviderIcons[provider.name]} Sign in with {provider.name}</Button>
                        ))}
                    
                    <br></br>
                    <hr></hr><br></br>
                    No account yet? <Link prefetch={false} href="/signup" className="pl-5"><Button variant={'outline'} size={'sm'} style={{padding: '0 15px'}}>Create an Account</Button></Link>

                    <br></br><br></br><hr></hr><br></br>
                    <small>By continuing, you agree to our policies <a  href={process.env.LANDING_PAGE_URL + '/terms'}>terms of use</a> and <a href={process.env.LANDING_PAGE_URL + '/privacy'}>privacy policy</a> </small>
                </div>
            </div>
            <div className="right">
                <div className="image-container">
                    <Image style={{objectFit: "cover" }} priority={true}placeholder="blur" quality={100} src={AuthBgLight} alt="Login Screen Image"></Image>
                </div>
            </div>

            <div className="mode-toggle-holder">
                <ModeToggle></ModeToggle>
            </div>
        </div>
    </>
}